<template>
  <div>
    <div class="wrap message-wrap">
      <div class="header-wrap">
        <div class="top-header">
          <incBack></incBack>
          <h3 v-if="userIdx == -1">1:1문의</h3>
          <h3 v-else>{{ userInfo.username }}님</h3>
        </div>
      </div>

      <div class="body-wrap">
        <div class="chat" ref="chat" v-if="userIdx == -1" id="qnaChat">
          <div class="messages" v-for="(item, index) in chat" :key="index">
            <div class="time">
              {{ item[0].chatGroup }}
            </div>

            <div :class="{ 'message-me-wrap': subItem.qna_parent_qna_idx > 0, 'message-coach-wrap': subItem.qna_parent_qna_idx == null }" v-for="(subItem, subIndex) in item" :key="subIndex">
              <div class="message" :class="{ coach: subItem.qna_parent_qna_idx > 0, me: subItem.qna_parent_qna_idx == null }">
                <div v-html="subItem.qna_content"></div>
              </div>
              <span>{{ subItem.sendTime }}</span>
            </div>
          </div>
          <div class="input">
            <textarea v-model="input.chatContent"></textarea>
            <img src="@/assets/img/message_send.svg" alt="메시지 보내기 아이콘" @click="chatSend()" />
          </div>
        </div>
        <div class="chat" v-else id="message">
          <div class="messages" v-for="(item, index) in chat" :key="index">
            <div class="time">
              {{ item[0].chatGroup }}
            </div>
            <div :class="{ 'message-coach-wrap': subItem.sender == 'COACH', 'message-me-wrap': subItem.sender == 'USER' }" v-for="(subItem, subIndex) in item" :key="subIndex">
              <div class="message" :class="{ me: subItem.sender == 'COACH', coach: subItem.sender == 'USER' }">
                <div v-html="subItem.chatContent"></div>
              </div>
              <span>{{ subItem.sendTime }}</span>
            </div>
          </div>
          <div class="input">
            <textarea v-model="input.chatContent"></textarea>
            <img src="@/assets/img/message_send.svg" alt="메시지 보내기 아이콘" @click="chatSend()" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import incBack from "@/components/inc/inc_back.vue";
import dayjs from "dayjs";
import { groupBy } from "@/utils/common";
export default {
  name: "message",
  props: {
    userIdx: {
      type: [Number, String],
      default: 0,
    },
  },
  data: () => ({
    chat: [],
    input: {
      userIdx: 0,
      coachIdx: 0,
      origin: "COACH",
      chatContent: "",
      isRead: false,
    },
    userInfo: {},
    detailList: "",
    loading: false,
    isShowCheckBtn: false,
  }),
  components: {
    incBack,
  },
  created() {
    this.loading = true;
  },
  async mounted() {
    if (this.userIdx == -1) {
      this.getQnaDetail();
    } else {
      let returnTemp = await this.getChatDetail();
      this.groupByChatList(returnTemp);

      this.$nextTick(() => {
        window.scrollTo(0, document.body.scrollHeight);
      });

      this.detailList = setInterval(() => {
        this.getChatDetail();
      }, 2000);
    }
  },
  methods: {
    getQnaDetail() {
      this.axios
        .get(`/qna/user/${this.$store.state.userInfo.userIdx}`)
        .then((res) => {
          // console.log(res);
          if (res.data.success) {
            let temp = res.data.data;
            this.groupByChatList(temp);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    chatSend() {
      if (this.input.chatContent == "") {
        alert("내용을 입력해주세요.");
        return false;
      }
      if (this.userIdx == -1) {
        let params = {
          qnaContent: this.input.chatContent,
        };
        this.axios
          .post("/qna/coach", params)
          .then((res) => {
            if (res.data.success) {
              this.$router.go(0);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.input.userIdx = this.userIdx;
        this.input.coachIdx = this.$store.state.userInfo.idxTbCoarch;
        let params = this.input;
        this.axios
          .post("/chat/send", params)
          .then((res) => {
            // console.log(res);
            if (res.data.success) {
              this.input.chatContent = "";
              let temp = res.data.contentinfo.chatList;
              this.groupByChatList(temp);

              setTimeout(() => {
                window.scrollTo(0, document.body.scrollHeight);
              }, 100);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    getChatDetail() {
      let params = {
        userIdx: this.userIdx,
        coachIdx: this.$store.state.userInfo.idxTbCoarch,
        origin: "COACH",
      };
      return this.axios
        .get("/chat/detail", { params })
        .then((res) => {
          let tempReturn = [];
          // console.log(res);
          if (res.data.success) {
            let temp = res.data.contentinfo.chatList;
            this.userInfo = res.data.contentinfo.userInfo;
            this.groupByChatList(temp);
            tempReturn = temp;
          }

          return tempReturn;
        })
        .catch((err) => {
          console.log(err);

          return [];
        });
    },

    groupByChatList(temp) {
      for (let item of temp) {
        let groupDate = dayjs(item.chatRegistDatetime).format("YYYY년 MM월 DD일");
        this.$store.commit("setCoachingDays", dayjs(item.chatRegistDatetime).day());
        let days = this.$store.state.coachingDays;

        item.chatGroup = groupDate + " " + days + "요일";
        item.sendTime = dayjs(item.chatRegistDatetime).format("HH:mm");
      }
      this.chat = groupBy(temp, "chatGroup");
    },
  },
  destroyed() {
    clearInterval(this.detailList);
  },
};
</script>
<style lang="scss" scoped>
.header-wrap {
  width: 100%;
  position: fixed;
  background: #fff;
  z-index: 1;
  .top-header {
    width: 90%;
    margin: 0 auto;
  }
}
</style>
